import { QuickscanProvider } from "@/contexts/QuickscanContext";
import { QuickscanContainer } from "@/components/quickscan/QuickscanContainer";

const QuickscanPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800">
      <QuickscanProvider>
        <QuickscanContainer />
      </QuickscanProvider>
    </div>
  );
};

export default QuickscanPage;